
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ValidationProvider, extend } from 'vee-validate';
import Icon from '@/components/UI/Icon.vue';
import { required } from 'vee-validate/dist/rules';
import { JobComplianceAttribute } from '@/models/JobComplianceTypes';
import { AttributeItem } from '@/store/modules/staticData/staticDataTypes';
import store from '@/store';

extend('required', {
  ...required,
  message: 'This field is required',
});

@Component({
  components: {
    Icon,
    ValidationProvider,
  },
})
export default class SelectAttributes extends Vue {
  @Prop({ type: Array, required: true }) public chosenAttrs: [];
  @Prop({ type: String, required: true }) public name: string;

  public loading = false;
  public attributeValue = '';
  public selectItems: JobComplianceAttribute[] = [];
  public showOptions = false;
  public arrowIdx = -1;

  private attributeList: AttributeItem[];

  public handleInput(evt: string): void {
    const filteredItems = this.attributeList.filter(
      x => `${x.description}`.toUpperCase().indexOf(evt.toUpperCase()) >= 0,
    );
    this.selectItems = [...filteredItems];
  }

  public inputKeyPressed(evt: KeyboardEvent): void {
    // Open dropdown on Focus
    if (!this.showOptions) {
      this.showOptions = true;
      this.arrowIdx = -1;
    }
    // Close dropdown when "Escape" pressed
    if (evt.code === 'Escape') {
      this.showOptions = false;
      this.arrowIdx = -1;
    }
    // ArrowDown / ArrowUp pressed
    if (evt.code === 'ArrowDown' && this.arrowIdx < this.selectItems.length - 1) {
      this.arrowIdx += 1;
      this.fixScrolling();
    }
    if (evt.code === 'ArrowUp' && this.arrowIdx >= 1) {
      this.arrowIdx -= 1;
      this.fixScrolling();
    }
    // Enter pressed
    if (evt.code === 'Enter' && this.arrowIdx >= 0) {
      evt.preventDefault();
      const chosenAddress = this.attributeList.find(
        x => `${x.description}` === this.selectItems[this.arrowIdx].description,
      );
      if (chosenAddress) {
        this.showOptions = false;
        this.attributeValue = '';
        this.arrowIdx = -1;
        this.$emit('changed', chosenAddress, this.name.slice(-1));
      }
    }
  }

  private fixScrolling() {
    const options = this.$refs.options as HTMLFormElement;
    const scrollContainer = this.$refs.scrollContainer as HTMLFormElement;
    if (options && scrollContainer) {
      const liH = options[this.arrowIdx].clientHeight;
      scrollContainer.scrollTop = liH * this.arrowIdx;
    }
  }

  public async inputFocused(): Promise<void> {
    if (!this.attributeList) {
      this.attributeList = await store.getters['moduleStaticData/getAttributes'];
    }
    this.showOptions = true;
    const chosenAttrs = this.chosenAttrs.map((x: JobComplianceAttribute) => x.description.toUpperCase());
    if (this.chosenAttrs.length) {
      this.selectItems = [...this.attributeList.filter(x => chosenAttrs.indexOf(x?.description?.toUpperCase()) === -1)];
    } else {
      this.selectItems = [...this.attributeList];
    }
  }

  public inputBlured(): void {
    setTimeout(() => {
      this.showOptions = false;
    }, 200);
  }

  public handleItemClick(item: JobComplianceAttribute): void {
    this.showOptions = false;
    this.attributeValue = '';
    this.arrowIdx = -1;
    this.$emit('changed', item, this.name.slice(-1));
  }

  public clickedOutside(): void {
    this.showOptions = false;
  }
}
